module.exports = __webpack_public_path__ + "static/about_pic5-fd467f57b1932879ad516e9f2ed33833.png";